export const mockRecommendations = {
  Headlines: [
    { text: 'Best Nike Shoes' },
    { text: 'Nike Com Shoes' },
    { text: 'Fitness Gear For All You Do' },
  ],
  LongHeadlines: [
    { text: 'Style your summer. Discover your summer color. The latest from Nike basketball' },
    { text: 'Shipping on all orders. Customize your so-you shoes.' },
    { text: 'Shop member exclusive styles' },
  ],
  Descriptions: [
    { text: 'Discover you summer color. The latest from Nike.' },
    { text: 'Shop member exclusive styles' },
  ],
};

export const unlocalizedRecommendationTitle = {
  Headlines: _TL_('View recommended healines'),
  LongHeadlines: _TL_('View recommended long healines'),
  Descriptions: _TL_('View recommended descriptions'),
};
